import { ReactElement } from 'react'
import styled from 'styled-components'

import kolorsLogo from 'assets/images/logo-kolors-dark.svg'
import { GTBookingV2 } from 'gql/types.generated'

interface IBookingSalesChannelProps {
  booking: GTBookingV2
}

const LogoWrapper = styled.img`
  width: 60px;
  height: auto;
`

export const BookingSalesChannel = ({ booking }: IBookingSalesChannelProps): ReactElement => {
  switch (booking.salesChannel.id) {
    case process.env.KOLORS_MX_SALES_CHANNEL_ID:
      return <LogoWrapper src={kolorsLogo} />
    default:
      return <div>{booking.salesChannel.name}</div>
  }
}
